


import { Component, Prop, Vue } from "vue-property-decorator";

import { Subscription, GroupedLinesTargetByProduct } from "App/Models";
import { Subscriptions } from "App";
import { EventBus } from "App/IOC";

import PlaceholderCard from "Web/Components/Placeholders/PlacolderCard.vue";
import Form from "Web/Components/Form/Index.vue";
import FormField from "Web/Components/Form/Field.vue";
import FormFieldset from "Web/Components/Form/Fieldset.vue";

/* LE TABLEAU DES QUOTAS, SANS SON CADRE — 08/10/2026 : la fiche abonnement le
   pose dans sa carte « Quota » ( `Quota.vue` ), la fiche client dans son onglet
   « Quotas » ( Fred : « ajoute un onglet avec les quotas apres abonnement » ). */
@Component({
    components: {
        Field: FormField,
        Fieldset: FormFieldset,
        Form,
        PlaceholderCard
    }
})
export default class QuotaLines extends Vue {
    @Prop()
    Record?: Subscription;

    private groupedLines: GroupedLinesTargetByProduct[] = [];
    private loading: boolean = true;

    async created(): Promise<void> {
        await this.groupLines();
    }

    private async groupLines(): Promise<void> {
        if( this.Record === undefined )
            return;

        const [ groupedLines, error ] =
            await Subscriptions.GroupPriceTargetedLinesByProduct( this.Record );

        if( error !== undefined ) {
            EventBus.Publish( "Error", error );
            return;
        }

        this.groupedLines = groupedLines;
        this.loading = false;
    }
}
